import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker, useIntersectionObserver } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';

import * as APIS from "../../utils/service";


export default function Faqlist({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);
    const target = useRef(null);

    const [memberinfos, setmemberinfos] = useState(''); 
    const [faqcate, setfaqcate] = useState(configdata?.fag_cate);   
    const [faqselcate, setfaqselcate] = useState(configdata?.fag_cate[0]);   

    const [lists, setlists] = useState([]); 
    const [selfaqidx, setselfaqidx] = useState('');   
    const [page, setPage] = useState(0);   

    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });


    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
   
    useEffect(() => {
        listopen();
        setPage(1);
        observe(target.current);
    }, [faqselcate]);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            cate: faqselcate
        }
        APIS.postData('/v1/faq/list', sender).then(({ data }) => {
            if(data){
                setlists(data);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }
    return(
        <Layout header={false} actives={''}>
            <div className='customercenter'>
                <div className='pagetabs_white margint20'>
                    <button onClick={() => { navigate('/Noticelist') }}>공지사항</button>
                    <button className='active' onClick={() => { navigate('/Faqlist') }}>FAQ</button>
                    <button onClick={() => { navigate('/Useguidelist')}}>이용가이드</button>
                </div>
                <div className='customercenterPage'>
                    <div className='fontsize24 bolds'>FAQ</div>
                    <div className='categorysArea'>
                        {faqcate?.length > 0 && faqcate?.map((x, i) => {
                            return (
                                <button
                                    key={i}
                                    onClick={() => {
                                        setfaqselcate(x);
                                    }}
                                    className={`${faqselcate === x ? 'active' : ''}`}
                                >   
                                    {x}
                                </button>
                            );
                        })}
                    </div>
                    <div>
                        <div className='faqlistArea'>
                            {lists?.length > 0 && lists?.map((x, i) => {
                                if(i > (page*10)){
                                    return;
                                }
                                return (
                                    <div 
                                        className={`faqlistView ${selfaqidx*1 === x?.idx ? 'active' : ''}`}
                                        key={i}
                                        style={{
                                            cursor: 'pointer', 
                                        }}
                                        onClick={() => {
                                            setselfaqidx(selfaqidx*1 === x?.idx ? '' : x?.idx);
                                        }}
                                    >
                                        <div>
                                            <div 
                                                className='textcut_online'
                                                style={{ 
                                                    display: 'inline-block', width: 'calc(100% - 140px)', textAlign: 'left',
                                                    fontWeight: 700, fontSize: 16
                                                }}
                                            >
                                                {x?.title}
                                            </div>  
                                            <div>
                                                {selfaqidx*1 === x?.idx ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M9.41091 6.07709C9.73634 5.75165 10.264 5.75165 10.5894 6.07709L16.4228 11.9104C16.7482 12.2359 16.7482 12.7635 16.4228 13.0889C16.0973 13.4144 15.5697 13.4144 15.2442 13.0889L10.0002 7.84485L4.75609 13.0889C4.43065 13.4144 3.90301 13.4144 3.57757 13.0889C3.25214 12.7635 3.25214 12.2359 3.57757 11.9104L9.41091 6.07709Z" fill="#666666"/>
                                                </svg>
                                                :
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.57757 6.91107C3.90301 6.58563 4.43065 6.58563 4.75609 6.91107L10.0002 12.1551L15.2442 6.91107C15.5697 6.58563 16.0973 6.58563 16.4228 6.91107C16.7482 7.23651 16.7482 7.76414 16.4228 8.08958L10.5894 13.9229C10.264 14.2484 9.73634 14.2484 9.41091 13.9229L3.57757 8.08958C3.25214 7.76414 3.25214 7.23651 3.57757 6.91107Z" fill="#666666"/>
                                                </svg>                                                
                                                }
                                            </div>  
                                        </div>
                                        {selfaqidx*1 === x?.idx &&
                                            <div className='detailcontents toastui-editor-contents' style={{ fontWeight: 'auto'}} dangerouslySetInnerHTML={{__html: x?.desc}} />
                                        }
                                    </div>
                                );
                            })}
                            {lists?.length === 0 &&
                                <div className='nolistArea'>
                                    FAQ가 없습니다.
                                </div>
                            }
                            <div ref={target} style={{ width: '100%', height: 1 }} />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

